const jp: any = {
  'delete': '削除',
  'UUID': 'UUID',
  'all': '全て',
  'button': {
    'cancel': 'キャンセル',
    'add': '追加',
    'register': '登録',
    'save': '保存',
    'edit': '編集',
    'delete': '削除',
    'login': 'ログイン',
    'logout': 'ログアウト',
    'setting_suru': '設定する',
    'search': '検索',
    'select': '選択',
    'export_csv': 'CSVエクスポート',
    'import_csv': 'CSVインポート',
  },
  'breadcrumb': {
    'operator_info_manage': 'オペレーター情報一覧',
    'unit_info_manage': 'ユニット情報一覧',
    'unit_detail': 'ユニット詳細情報',
    'news_info_manage': 'ニュース情報一覧',
    'question_info_manage': 'よくあるご質問情報一覧',
  },
  'label': {
    'search_placeholder': '検索...',
    'unit_name': 'ユニット名',
    'customer_name': '顧客名',
    'address': '所在地',
    'domains': 'ドメイン',
    'api_keys': 'APIキー',
    'token': 'トークン',
    'db_name': 'データベース名',
    'timezone': 'タイムゾーン',
    'yes': 'あり',
    'no': 'なし',
    'operator_name': 'オペレータ名',
    'unit': 'ユニット',
    'numof_operators': 'オペレータ数',
    'access_right': 'アクセス権限',
    'title': 'タイトル',
    'url': 'URL',
    'type': 'タイプ',
    'content': 'コンテンツ',
    'password': 'パスワード',
    'search_unit_info': 'ユニット情報検索',
    'logo': 'ロゴ',
    'detail': '詳細',
    'updated_at': '更新日',
    'threshold': 'WRペアリング閾値',
    'manage_features': '機能管理',
    'features': '機能',
    'status': '有効化',
    'stamp_rally': 'スタンプラリー',
    'work_recorder': 'チャート',
    'ip_camera': 'IPカメラ',
    'geofence': 'ジオフェンス',
    'floor_name': 'フロア名',
    'floor_id': 'フロアID',
    'building_name': '建物名',
    'floor': 'フロア',
    'floor_file': '図面ファイル',
    'major': 'Major',
    'minor': 'Minor',
    'lon': '経度',
    'lat': '緯度',
    'camera': 'カメラ',
    'beacon_uuid': 'ビーコンUUID',
    'san_id': 'カードID',
    'user_id': '利用者ID',
    'user': '利用者',
    'username': '氏名',
    'category': '分類',
    'category_name': '分類名',
    'people': 'ヒト',
    'things': 'モノ',
    'card_number': 'カード番号',
    'mobile_username': 'モバイルユーザー名',
    'static': '固定位置',
    'carried': '移動する',
    'confirm_delete': '削除確認',
    'location': 'ロケーション',
    'stat': '統計',
    'ip_whitelist': '許可するIPアドレス',
    'ip_address': 'IPアドレス',
    'feature': '特徴',
    'width': '横幅',
    'height': '高さ',
    'order': 'ご注文',
    'full': 'フル',
    'user_type': 'ユーザータイプ',
    'filter_text': 'フィルターテキスト',
    'all': '全タイプ',
    'name': '名称',
    'indoor_map': '屋内マップ',
    'outdoor_map': '屋外マップ',
    'link': 'リンク',
  },
  'option': {
    'type': {
      'info': '情報',
      'important': '重要',
    },
    'access_right': {
      'owner': 'オーナー',
      'manager': 'マネージャー',
      'observer': 'オブザーバー',
    },
    'api_key_access_right': {
      'owner': 'オーナー',
      'admin': '管理者',
      'viewer': 'ビューア',
    },
  },
  'menu': {
    'dashboard': 'ダッシュボード',
    'system_menu': 'システムメニュー',
    'manage_unit': '分類情報管理',
    'manage_operator': 'カード管理',
    'manage_news': 'ビーコン管理',
    'manage_question': 'フロア管理',
    'unit': 'ユニット',
    'operator': 'ユーザ認証',
    'news': 'ニュース',
    'question': 'よくある質問',
    'information': '情報',
    'floor': 'フロア',
    'card': 'カード',
    'user': 'ユーザー',
    'beacon': 'ビーコン',
    'tracking_data': '追跡データ',
    'widget_setting': 'ウィジェット設定'
  },
  'messages': {
    'data_not_found': 'データが見つかりませんでした。',
    'username_required': 'ユーザー名を入力してください。',
    'password_required': 'パスワードを入力してください。',
    'are_you_sure_want_to_delete': '削除した情報は復元できませんが、よろしいですか？',
    'has_refs_data_are_you_sure_want_to_delete': '関連する情報がありますが、削除しますか？',
    'drop_file_here_or_select_a_file': 'ここにファイルをドロップまたはファイルを選択して下さい。',
    'save_success': '保存は正常に完了されました。',
    'update_success': '更新は正常に完了されました。',
    'delete_success': '削除は正常に完了されました。',
    'field_is_required': '入力してください。',
    'ask_for_delete': 'これらのフィールドを本当に削除しますか?',
    'can_dnd_order': '行をドラッグして別の行に移動することで、順番を入れ替えることができます。',
    're_order_success': '注文{from}を注文{to}に移動しました。'
  },
  'content': {
    'first_ex_location': '信号データはビーコンから送信され、JBOXサーバーから取得されます',
    'second_ex_location': 'このデータは、ユニット全体の追跡データに影響します',
    'first_ex_stats': 'ロケーションコレクションからの計算によって生成されたデータ',
    'second_ex_stats': 'このデータは、ワークレコーダー画面で使用されます',
  },
  'pagination': {
    'per_page': '件表示',
    'of_pages': 'ページ目',
  },
  'widget_setting': {
    'user_search': 'ユーザ検索',
    'indoor': '屋内マップ',
    'outdoor': '屋外マップ'
  },
  'placeholder': {
    'input_filter': 'フィルタリングするテキストを入力します。',
    'input_order': '序数を入力する'
  }
}

export default jp
